module.exports = __webpack_public_path__ + "static/media/report.b8d16b10.svg";